import axios from 'axios';
import { API_URL } from '../../@jumbo/constants/AppConstants';

export const FETCH_PROVVIGIONI_START = 'FETCH_PROVVIGIONI_START';
export const FETCH_PROVVIGIONI_SUCCESS = 'FETCH_PROVVIGIONI_SUCCESS';
export const FETCH_PROVVIGIONI_FAILURE = 'FETCH_PROVVIGIONI_FAILURE';

export const FETCH_PROVVIGIONE_START = 'FETCH_PROVVIGIONE_START';
export const FETCH_PROVVIGIONE_SUCCESS = 'FETCH_PROVVIGIONE_SUCCESS';
export const FETCH_PROVVIGIONE_FAILURE = 'FETCH_PROVVIGIONE_FAILURE';

export const SAVE_PROVVIGIONE_START = 'SAVE_PROVVIGIONE_START';
export const SAVE_PROVVIGIONE_SUCCESS = 'SAVE_PROVVIGIONE_SUCCESS';
export const SAVE_PROVVIGIONE_FAILURE = 'SAVE_PROVVIGIONE_FAILURE';

export const VERSIONA_PROVVIGIONE_START = 'VERSIONA_PROVVIGIONE_START';
export const VERSIONA_PROVVIGIONE_SUCCESS = 'VERSIONA_PROVVIGIONE_SUCCESS';
export const VERSIONA_PROVVIGIONE_FAILURE = 'VERSIONA_PROVVIGIONE_FAILURE';

export const DELETE_PROVVIGIONE_START = 'DELETE_PROVVIGIONE_START';
export const DELETE_PROVVIGIONE_SUCCESS = 'DELETE_PROVVIGIONE_SUCCESS';
export const DELETE_PROVVIGIONE_FAILURE = 'DELETE_PROVVIGIONE_FAILURE';

export const ARCHIVIA_PROVVIGIONE_START = 'ARCHIVIA_PROVVIGIONE_START';
export const ARCHIVIA_PROVVIGIONE_SUCCESS = 'ARCHIVIA_PROVVIGIONE_SUCCESS';
export const ARCHIVIA_PROVVIGIONE_FAILURE = 'ARCHIVIA_PROVVIGIONE_FAILURE';

export const fetchProvvigioni = (archiviata = 0) => {
  return dispatch => {
    dispatch({ type: FETCH_PROVVIGIONI_START });

    axios
      .get(`${API_URL}/getProvvigioni.php?archiviata=${archiviata}`)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: FETCH_PROVVIGIONI_SUCCESS,
            payload: response.data.data,
          });
        } else {
          dispatch({
            type: FETCH_PROVVIGIONI_FAILURE,
            payload: response.data.error || 'Errore nel caricamento provvigioni',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_PROVVIGIONI_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const fetchProvvigione = id => {
  return dispatch => {
    dispatch({ type: FETCH_PROVVIGIONE_START });

    axios
      .get(`${API_URL}/getProvvigione.php?id=${id}`)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: FETCH_PROVVIGIONE_SUCCESS,
            payload: response.data.data,
          });
        } else {
          dispatch({
            type: FETCH_PROVVIGIONE_FAILURE,
            payload: response.data.error || 'Errore nel caricamento provvigione',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_PROVVIGIONE_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const saveProvvigione = provvigioneData => {
  return dispatch => {
    dispatch({ type: SAVE_PROVVIGIONE_START });

    axios
      .post(`${API_URL}/SalvaProvvigione.php`, provvigioneData)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: SAVE_PROVVIGIONE_SUCCESS,
            payload: response.data,
          });
        } else {
          dispatch({
            type: SAVE_PROVVIGIONE_FAILURE,
            payload: response.data.error || 'Errore nel salvataggio provvigione',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: SAVE_PROVVIGIONE_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const versionaProvvigione = provvigioneData => {
  return dispatch => {
    dispatch({ type: VERSIONA_PROVVIGIONE_START });

    axios
      .post(`${API_URL}/VersionaProvvigione.php`, provvigioneData)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: VERSIONA_PROVVIGIONE_SUCCESS,
            payload: response.data,
          });
          dispatch(fetchProvvigione(provvigioneData.id));
        } else {
          dispatch({
            type: VERSIONA_PROVVIGIONE_FAILURE,
            payload: response.data.error || 'Errore nella creazione revisione',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: VERSIONA_PROVVIGIONE_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const deleteProvvigione = id => {
  return dispatch => {
    dispatch({ type: DELETE_PROVVIGIONE_START });

    axios
      .post(`${API_URL}/eliminaProvvigione.php`, { id })
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: DELETE_PROVVIGIONE_SUCCESS,
            payload: id,
          });
        } else {
          dispatch({
            type: DELETE_PROVVIGIONE_FAILURE,
            payload: response.data.error || 'Errore nella cancellazione provvigione',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: DELETE_PROVVIGIONE_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const archiviaProvvigione = (id, archivia = true) => {
  return dispatch => {
    dispatch({ type: ARCHIVIA_PROVVIGIONE_START });

    const endpoint = archivia ? 'ArchiviaProvvigione.php' : 'RipristinaProvvigione.php';

    axios
      .post(`${API_URL}/${endpoint}`, { id })
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: ARCHIVIA_PROVVIGIONE_SUCCESS,
            payload: { id, archivia },
          });
          dispatch(fetchProvvigioni());
        } else {
          dispatch({
            type: ARCHIVIA_PROVVIGIONE_FAILURE,
            payload: response.data.error || 'Errore operazione archivio',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: ARCHIVIA_PROVVIGIONE_FAILURE,
          payload: error.message,
        });
      });
  };
};
